import TripSegment from '../TripSegment';
import { type LocationMismatch, type SegmentOption } from '../types';
import type Flight from './Flight';

export class FlightSegment extends TripSegment<Flight> {
    constructor(
        trips: Flight[],
        options: SegmentOption[],
        stopsDescription: string,
        public override collapseTrips = true,
        private _connectionTime = '',
        private _totalTime = '',
        private _isInternational = false,
        compactOptions = options,
        locationMismatch: LocationMismatch = {
            isOriginMismatched: false,
            isDestinationMismatched: false,
        }
    ) {
        super(trips, options, stopsDescription, collapseTrips, compactOptions);
        this.isOriginMismatched = locationMismatch.isOriginMismatched;
        this.isDestinationMismatched = locationMismatch.isDestinationMismatched;
    }

    override get duration(): number {
        if (this._isInternational) {
            const matcher = /(\d*)[.]?(\d{2}):(\d{2}):(\d{2})/;
            const [, cd, ch, cm, cs] =
                this._connectionTime.match(matcher) || [];
            const [, td, th, tm, ts] = this._totalTime.match(matcher) || [];
            const summedDuration = dayConfig
                .duration({
                    days: +(cd || '0'),
                    hours: +ch,
                    minutes: +cm,
                    seconds: +cs,
                })
                .add({
                    days: +(td || '0'),
                    hours: +th,
                    minutes: +tm,
                    seconds: +ts,
                });
            return summedDuration.as('seconds');
        }
        return super.duration;
    }

    override get digest(): Flight[] {
        const [first] = this.trips;
        const last = this.trips[this.trips.length - 1];
        if (first == null) {
            return [];
        }
        return [
            <Flight>{
                ...first,
                arrivalDateTime: last.arrivalDateTime,
                arrivalTime: last.arrivalTime,
                stops:
                    this.trips.reduce((acc, t) => acc + t.stops, 0) +
                    this.trips.length -
                    1,
                nextDayCount:
                    this.trips.reduce((acc, t) => acc + t.nextDayCount, 0) +
                    this.trips.length -
                    1,
                duration: this.duration,
                destination: last.destination,
                destinationCityName: last.destinationCityName,
                destinationCode: last.destinationCode,
                destinationTerminal: last.destinationTerminal,
            },
        ];
    }
}
